export type ShareTarget = {
  /** Public URL the share points at. */
  url: string;
  /** Track/album title or artist name. */
  title: string;
  kind: "track" | "album" | "artist";
  /** Byline for tracks and albums. */
  artistName?: string;
  artworkUrl?: string | null;
};

export function isTouchDevice() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(pointer: coarse)").matches
  );
}

export function hasNativeShare() {
  return (
    typeof navigator !== "undefined" && typeof navigator.share === "function"
  );
}

export function canNativeShare(url: string) {
  return hasNativeShare() && navigator.canShare?.({ url }) !== false;
}

export function isAbortError(error: unknown) {
  return error instanceof DOMException && error.name === "AbortError";
}

export function getShareText({ title, kind, artistName }: ShareTarget) {
  if (kind === "artist") return `${title} on Lutely`;
  const by = artistName ? ` by ${artistName}` : "";
  return `"${title}"${by} on Lutely`;
}

export function getShareData(target: ShareTarget): ShareData {
  return {
    title: target.title,
    text: getShareText(target),
    url: target.url,
  };
}

export function getChannelLinks(target: ShareTarget) {
  const url = encodeURIComponent(target.url);
  const text = getShareText(target);
  return {
    x: `https://x.com/intent/tweet?text=${encodeURIComponent(text)}&url=${url}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
    email: `mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(`${text}\n\n${target.url}`)}`,
    messenger: `fb-messenger://share/?link=${url}`,
    whatsapp: `https://wa.me/?text=${encodeURIComponent(`${text} ${target.url}`)}`,
  };
}
